export const loadImageMetaData = path =>
  new Promise(resolve => {
    const img = new Image()
    img.onload = () =>
      resolve({ width: img.naturalWidth, height: img.naturalHeight })
    img.onerror = () => resolve({ error: "error" })

    img.src = path
  })
